import type { IDeviceTypeCount } from '../types';

import { useHeatmapSettingContext, EDeviceType } from '@gem-sdk/heatmap-react';
import { useHeatmapAnalyticContext } from './view-context';
import { useCallback, useMemo } from 'react';

interface IAnalyticDeviceTypeResult {
  data?: IDeviceTypeCount;
  getByDeviceType: (deviceType: EDeviceType) => IDeviceTypeCount | undefined;
}

export const useHeatmapAnalyticDeviceType = (): IAnalyticDeviceTypeResult => {
  const deviceType = useHeatmapSettingContext((state) => state.deviceType);
  const analyticsData = useHeatmapAnalyticContext((state) => state.data);

  const deviceTypeDistribution = useMemo<Record<EDeviceType, IDeviceTypeCount | undefined>>(() => {
    const deviceAnalytic: Record<EDeviceType, IDeviceTypeCount | undefined> = {
      [EDeviceType.DesktopLarge]: undefined,
      [EDeviceType.Desktop]: undefined,
      [EDeviceType.Mobile]: undefined,
      [EDeviceType.Tablet]: undefined,
    };

    if (!analyticsData?.deviceTypeDistribution) return deviceAnalytic;

    for (const d of analyticsData.deviceTypeDistribution) {
      deviceAnalytic[d.deviceType] = d;
    }
    return deviceAnalytic;
  }, [analyticsData?.deviceTypeDistribution]);

  const getByDeviceType = useCallback(
    (deviceType?: EDeviceType): IDeviceTypeCount | undefined => {
      if (!deviceType) return;

      return deviceTypeDistribution[deviceType];
    },
    [deviceTypeDistribution],
  );

  return { getByDeviceType, data: getByDeviceType(deviceType) };
};
